import { KeyPersons } from '../../KeyPersons';
import { SummaryInfoWrapper } from './SummaryInfoWrapper';

type KeyPersonsCardProps = {
  companyId: number;
  businessEntityId: number;
  onGoToForm: () => void;
};

export const KeyPersonsCard = ({
  companyId,
  onGoToForm,
  businessEntityId,
}: KeyPersonsCardProps) => {
  return (
    <SummaryInfoWrapper title="Key Persons" onGoToForm={onGoToForm}>
      <KeyPersons
        companyId={companyId}
        businessEntityId={businessEntityId}
        isEditable={false}
        shouldShowViewKeyPersonButton={false}
        hideTitle
      />
    </SummaryInfoWrapper>
  );
};
